<div class="container">
	<div class="content">
		<div class="ui-lg-12 ui-md-12 ui-g-12 text-center p-0">
			<img alt="SmartyCubes Logo" class="logo" src="./assets/img/smartyCubes-logo.png" />
			<h3 style="margin: 0px">
				Şimdi
				<span class="highlight">ücretsiz</span>
				denemeye başlayın!
			</h3>
		</div>
		<div class="form-container">
			<form (submit)="registration()" [formGroup]="form" novalidate>
				<p-card class="nice-border" styleClass="ui-card-shadow">
					<div class="ui-g">
						<div class="ui-lg-12 ui-md-12 ui-g-12">
							<label>
								<b>{{ 'registration.name' | translate }}</b>
							</label>
							<input class="w-100" formControlName="name" maxlength="100" name="name" pInputText type="text" />
							<sis-validation-summary [form]="form" [visible]="invalidForm" name="name"></sis-validation-summary>
						</div>

						<div class="ui-lg-12 ui-md-12 ui-g-12">
							<label>
								<b>{{ 'registration.lastname' | translate }}</b>
							</label>
							<input class="w-100" formControlName="lastname" maxlength="100" name="lastname" pInputText type="text" />
							<sis-validation-summary [form]="form" [visible]="invalidForm" name="lastname"></sis-validation-summary>
						</div>
						<div class="ui-lg-12 ui-md-12 ui-g-12">
							<label>
								<b>{{ 'registration.email' | translate }}</b>
							</label>
							<input class="w-100" formControlName="email" name="email" pInputText type="text" />
							<span class="information">
								<i class="fas fa-question-circle"></i>
								{{ 'registration.email-information' | translate }}
							</span>
							<sis-validation-summary
								[form]="form"
								[visible]="invalidForm"
								name="email"
								class="mt5"></sis-validation-summary>
						</div>

						<div class="ui-lg-12 ui-md-12 ui-g-12">
							<label>
								<b>{{ 'registration.phone' | translate }}</b>
							</label>
							<input
								[mask]="phoneNumberFormat"
								[placeholder]="phoneNumberFormat"
								class="w-100"
								formControlName="phone"
								maxlength="16"
								pInputText />
						</div>
						<div class="ui-g-12">
							<div class="form-group">
								<label style="font-size: 12px">
									<input formControlName="privacyPolicy" type="checkbox" />
									{{ 'registration.privacyPolicy' | translate }}
								</label>
								<p>
									<a
										href="https://smartycubes.com/kisisel-verilerin-korunmasi-ve-islenmesine-iliskin-aydinlatma-metni/"
										style="font-size: 12px; color: #008bec"
										target="_blank">
										{{ 'registration.policyLink' | translate }}
									</a>
								</p>
							</div>
						</div>

						<ng-template #footer>
							<div class="ui-lg-12 login-border text-right">
								<button
									pButton
									type="submit"
									class="g-recaptcha tt-btn-link tt-btn btn-md hover_translate ui-dark-button w-100 ui-button"
									[label]="'registration.submit' | translate"
									data-action="submit"
									data-callback="onSubmit"
									data-sitekey="6LdhNOwpAAAAALa1Jaqz9cqrtu1wNYgSy6mDoANi"
									[disabled]="form.invalid"></button>
							</div>
						</ng-template>
					</div>
				</p-card>
			</form>
			<p-dialog
				(onHide)="onHideEvent()"
				[(visible)]="display"
				[contentStyle]="{ 'max-height': '600px' }"
				[header]="dialogTitle"
				[modal]="true"
				class="dialog-center"
				[style]="{ width: '400px', minWidth: '200px' }">
				<div class="p-panel-header">
					<span>{{ 'registration.success' | translate }}</span>
				</div>
				<div>
					<img class="dialog-img" src="assets/img/send-mail-icon.png" alt="" />
				</div>
				<div class="ui-lg-12 ui-md-12 ui-g-12">
					<p>{{ 'registration.message' | translate }}</p>
				</div>
			</p-dialog>
		</div>
	</div>
</div>
